'use strict';

(function () {
  'use strict';

  angular.module('msProfile').component('msSettings', {
    bindings: {
      components: '<',
      user: '<',
      pane: '<'
    },
    templateUrl: 'profile/pages/settings.html',
    controller: ['NotifyingSvc', 'userSvc', 'focus', '$state', function (NotifyingSvc, userSvc, focus, $state) {
      var vm = this;
      vm.$onInit = init;
      vm.navigatePane = navigatePane;
      vm.accountDeleteClicked = accountDeleteClicked;
      vm.hasRequestedAccountDeletion = false;
      vm.eligilbeForDeletion = true;
      vm.deletionFlow = 'AUTOMATED';
      vm.currentNavItem = $state.current.name;

      // workaround for md-nav-bar for accessibility
      var navElement = angular.element(document.querySelector('._md-nav-bar-list'));
      navElement.attr('tabindex', '0');

      ///////////////////////////////////////

      function init() {
        NotifyingSvc.subscribe(NotifyingSvc.EVENTS.PROFILE_SAVED, function (event, resp) {
          if (resp.components) {
            vm.components = resp.components;
          }
        });
        userSvc.getAccountDeletionRequest().then(function (response) {
          if (response.status === 'REQUESTED') {
            vm.hasRequestedAccountDeletion = true;
          }
        }, function (err) {
          if (err.status === 403) {
            vm.eligilbeForDeletion = false;
          }
        });
        // get deletion flow
        userSvc.getUser().then(function (user) {
          if (user) {
            var deletionFlow = _.get(user, 'accessCode.accountDeletionFlow');
            if (deletionFlow) {
              vm.deletionFlow = deletionFlow;
            }
          }
        });
      }

      function navigatePane(state) {
        vm.pane = state;
      }

      function accountDeleteClicked($event) {
        if (vm.hasRequestedAccountDeletion) {
          cancelDeletionRequest();
        } else {
          requestDeletion($event);
        }
      }

      function requestDeletion($event) {
        $event.currentTarget.blur();
        // Display confirm dialog
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
          templateUrl: 'vnext/templates/account-deletion-confirm.html',
          controller: 'ConfirmModalCtrl',
          inputs: {
            heading: '',
            body: [],
            focusableId: 'account-deletion-title',
            deletionFlow: vm.deletionFlow
          },
          closeCallback: function closeCallback(result) {
            // Focus 'Request deletion' on modal close
            focus.byId('account-delete-button', 500);
            if (result.confirm && result.reason) {
              userSvc.requestAccountDeletion(result.reason).then(function () {
                vm.hasRequestedAccountDeletion = true;
              });
            }
          }
        });
      }

      function cancelDeletionRequest() {
        userSvc.cancelAccountDeletion().then(function () {
          vm.hasRequestedAccountDeletion = false;
          vm.isDeletionAlert = true;
        });
      }
    }]
  });
})();